module.exports = __webpack_public_path__ + "static/media/file_solid.55de0e6a.svg";